import React from 'react'
import { Switch } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'
import { DadataFakeResponsesLazy, DrsFakeResponsesLazy, KrDrsFakeResponsesLazy } from 'Pages/admin'

export const FakeResponsesRoutes = () => {
	return (
		<Switch>
			<LazyRoute
				path={FrontUrls.admin_panel.fake_responses_dadata_suggest_by_id_party}
				key={FrontUrls.admin_panel.fake_responses_dadata_suggest_by_id_party}
				lazyComponent={DadataFakeResponsesLazy}
			/>
			<LazyRoute
				path={FrontUrls.admin_panel.fake_responses_dadata_suggest_drs}
				key={FrontUrls.admin_panel.fake_responses_dadata_suggest_drs}
				lazyComponent={DrsFakeResponsesLazy}
			/>
			<LazyRoute
				path={FrontUrls.admin_panel.fake_responses_rbidos_load_company}
				key={FrontUrls.admin_panel.fake_responses_rbidos_load_company}
				lazyComponent={KrDrsFakeResponsesLazy}
			/>
		</Switch>
	)
}
